export default __webpack_public_path__ + "22835fd9f1bfae2cbf1ff88422b3e7a9.svg";